import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { color } from '@metro-ui/tokens/js';
import { css } from '@emotion/core';
import { fontStack } from '../../utils';
export var BasicTable = styled(function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement("table", __assign({}, props), children);
})(function (_a) {
    var _b = _a.zebra, zebra = _b === void 0 ? 'rows' : _b;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n\n    width: 100%;\n    background: ", ";\n    border-collapse: collapse;\n    border-bottom: 1px solid ", ";\n    & tr:nth-of-type(even) {\n      ", "\n    }\n  "], ["\n    ", ";\n\n    width: 100%;\n    background: ", ";\n    border-collapse: collapse;\n    border-bottom: 1px solid ", ";\n    & tr:nth-of-type(even) {\n      ", "\n    }\n  "])), fontStack, color.inverted, color.palette.grey.tint[90], zebra === 'rows' && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), color.palette.grey.tint[95]));
});
BasicTable.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    zebra: PropTypes.oneOf(['rows', 'none']),
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=BasicTable.js.map